// extracted by mini-css-extract-plugin
module.exports = {"subscribe_strip":"AMRlJ","showStrip":"kjIgv","toiplus_logo":"d9ZYO","inner_content":"ju62g","text_strong":"JhBjH","close":"GrAWz"};